module.exports = __webpack_public_path__ + "img/wiki.b61dcaaf.png";